import { PiggyBank } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { OWN_HOME_DOWN_PAYMENT_SAVING } from "web_myplann/Inspiration/OwnHome/constants";
import type { OwnHomeContext } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";
import { getDownPaymentYears } from "web_myplann/Inspiration/OwnHome/Utils/getDownPaymentYears";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";
import { Callout } from "web_myplann/Shared/Components/Callout";

const R = Resources.Inspiration.OwnHome.Result;

type Props = {
	context: OwnHomeContext;
};

export const DownPaymentSection: FC<Props> = ({ context }) => {
	const { t } = useResource();

	const gap = context.savingsGap ?? 0;

	return (
		<InspirationSection title={t(R.downPaymentTitle)}>
			<Callout
				color="amber"
				icon={PiggyBank}
				title={t(R.downPaymentHeading, {
					gap: formatInspirationMoney(gap),
				})}
				description={t(R.downPaymentText, {
					downPayment: formatInspirationMoney(context.downPayment),
					savings: formatInspirationMoney(context.savings),
					monthly: formatInspirationMoney(OWN_HOME_DOWN_PAYMENT_SAVING),
					years: getDownPaymentYears(gap),
				})}
			/>
		</InspirationSection>
	);
};
